export async function generateThumbnail(
  file: File,
  options: {
    maxWidth?: number;
    maxHeight?: number;
    quality?: number;
    outputType?: string;
    genFile?: boolean;
  } = {}
) {
  const { maxWidth = 200, maxHeight = 200, quality = 0.5, outputType, genFile = false } = options;

  function calculateAspectRatioFit(
    srcWidth: number,
    srcHeight: number,
    maxWidth: number,
    maxHeight: number
  ): { width: number; height: number } {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return {
      width: srcWidth * ratio,
      height: srcHeight * ratio,
    };
  }

  return new Promise<{
    file?: File;
    data: string;
    originalWidth: number;
    originalHeight: number;
    width: number;
    height: number;
  }>((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      reject(new Error('File type is not image.'));
      return;
    }

    const imgUrl = URL.createObjectURL(file);
    const img = new window.Image();

    img.onload = async () => {
      URL.revokeObjectURL(imgUrl);

      try {
        const { width, height } = calculateAspectRatioFit(
          img.width,
          img.height,
          maxWidth,
          maxHeight
        );

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d')!;

        ctx.drawImage(img, 0, 0, width, height);

        const result = {
          data: canvas.toDataURL(outputType || file.type, quality),
          originalWidth: img.width,
          originalHeight: img.height,
          width,
          height,
        };

        if (genFile) {
          canvas.toBlob(
            async (blob: any) => {
              const newFile = new File([blob], file.name, {
                type: outputType || file.type,
              });
              resolve({ ...result, file: newFile });
            },
            outputType || file.type,
            quality
          );
          return;
        }
        resolve(result);
      } catch (error) {
        reject(error);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(imgUrl);
      reject(new Error('Image load error.'));
    };

    img.src = imgUrl;
  });
}
